import { FC, forwardRef, useImperativeHandle, useState } from 'react';
import cs from 'classnames';
import { refactorSelection } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import { showInvalidFieldMsg } from '@/common/utils/ways';
import { getStandardTaskSelection, postDirectTaskUpdate } from '@/common/api/expandStore/expansiontask';
import { getCircleTaskDetail } from '@/common/api/expandStore/expansionCircleTask';
import styles from './index.module.less';
import { Col, Form, Modal, Row } from 'antd';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import V2Form from '@/common/components/Form/V2Form';
import V2FormInput from '@/common/components/Form/V2FormInput/V2FormInput';
import V2FormSelect from '@/common/components/Form/V2FormSelect/V2FormSelect';
import { FollowingStatus } from '../../ts-config';

/**
 * 拓店任务-部分字段编辑
 * @Description 拓店任务：森马（参考clusterA直营）
 */
const CircleTaskCreateDrawer: FC<{
  /** 提交表单后的回调 */
  onRefresh?: ()=>void,
  ref?: any,
}> = forwardRef(({
  onRefresh,
}, ref) => {

  useImperativeHandle(ref, () => ({
    init: methods.init,
  }));

  const [taskId, setTaskId] = useState<any>(null);
  const [form] = Form.useForm();
  const [requesting, setRequesting] = useState(false);
  const [selection, setSelection] = useState<{
    /** 跟进状态 */
    followingStatusList: any[],
    /** 紧急程度 */
    emergencyOptions: any[],
   }>({ followingStatusList: [], emergencyOptions: [] });

  const [visible, setVisible] = useState(false);

  const methods = useMethods({

    init(taskId: any) {
      setTaskId(taskId);
      setVisible(true);
      setTimeout(() => {
        methods.getSelection();
        methods.loadData();
      }, 0);
    },

    /** 加载详情信息 */
    loadData() {
      if (!taskId) {
        return;
      }
      getCircleTaskDetail({ id: taskId }).then((res) => {
        form.setFieldsValue({
          name: res.name,
          followingStatus: res.followingStatus,
          emergencyDegree: res.emergencyDegree,
        });
      });
    },

    /**
     * 获取下拉选项
     */
    getSelection: async () => {
      getStandardTaskSelection().then(res => {
        setSelection(val => ({ ...val,
          emergencyOptions: refactorSelection(res.emergencyDegree),
          // 产品要求过滤掉“已立项”选项，避免用户主动修改值
          followingStatusList: refactorSelection(res.followingStatusList).filter(item => item.value !== FollowingStatus.Launched)
        }));
      });
    },

    /**
     * 提交表单
     */
    onSubmit: async():Promise<void> => {
      form.validateFields().then((values: any) => {
        console.log('values', values);
        // 如果是多级，取最后一级，否则使用当前值
        const _emergencyDegree = Array.isArray(values.emergencyDegree) && values.emergencyDegree.length
          ? values.emergencyDegree[values.emergencyDegree.length - 1]
          : values.emergencyDegree;
        const params: any = {
          id: taskId,
          name: values.name,
          followingStatus: values.followingStatus,
          emergencyDegree: _emergencyDegree,
        };
        console.log('params', params);
        setRequesting(true);
        postDirectTaskUpdate(params).then(() => {
          V2Message.success('编辑拓店任务成功');
          setVisible(false);
          onRefresh && onRefresh();
        }, err => {
          setVisible(false);
          console.log('catch 失败', err);
          V2Message.error('编辑拓店任务失败');
        }).finally(() => {
          setRequesting(false);
        });
      }).catch((err) => {
        err && showInvalidFieldMsg(err.errorFields, 1);
      });
    },

    onCancel: () => {
      setVisible(false);
    },

  });

  return (
    <Modal
      title='编辑拓店任务'
      open={visible}
      destroyOnClose
      confirmLoading={requesting}
      bodyStyle={{ padding: 0, }}
      className={styles.simpleEditModal}
      onOk={methods.onSubmit}
      onCancel={methods.onCancel}
      // contentWrapperStyle={{
      //   minWidth: 'auto',
      //   width: '1008px',
      // }}
    >
      <V2Form form={form} className={cs('pt-12 pb-12 pl-24 pr-24')} >
        <Row gutter={24}>
          <Col span={12}>
            <V2FormInput required label='拓店任务名称' name='name' maxLength={50} />
          </Col>
          <Col span={12}>
            <V2FormSelect required label='跟进状态' name='followingStatus' options={selection.followingStatusList} />
          </Col>
          <Col span={12}>
            <V2FormSelect required label='紧急度' name='emergencyDegree' options={selection.emergencyOptions} />
          </Col>
        </Row>
      </V2Form>
    </Modal>
  );
});
export default CircleTaskCreateDrawer;
